export const SEND_POOL_REQUEST_SUCCESS = 'SEND_POOL_REQUEST_SUCCESS';

export const sendPoolRequestSuccess = () => ({
    type: SEND_POOL_REQUEST_SUCCESS,
});
